// extracted by mini-css-extract-plugin
export default {"page":"page-FCsA","content":"content-keai","logo":"logo-NAZA","footer":"footer-acIg"};